import React from 'react';

interface contactPros {
	name: string;
	duty: string;
	desc: string;
}
export interface ConsultingContactProps {
	addClass?: string;
	contactUs: contactPros[];
}
export default function ConsultingContact(props: ConsultingContactProps) {
	const { contactUs } = props;

	return (
		<div className="consult-contact">
			<div className="consult-contact-inner">
				<strong className="title">Contact us</strong>

				<ul className="contact-list">
					{contactUs.map((item, index) => (
						<li key={index}>
							<p className="name">
								{item.name}
								<span>{item.duty}</span>
							</p>
							<div className="desc">
								{item.desc.split('\n').map((line, idx) => (
									<React.Fragment key={idx}>
										{line}
										<br />
									</React.Fragment>
								))}
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
}
